

<template>
  <!-- https://michalsnik.github.io/aos/ -->
 <v-container>
    <v-card
      class="mx-auto"
      max-width="550"
      min-height="600"
    >

    <v-app-bar  color="grey darken-1" dark dense>
      <v-spacer></v-spacer>

      <v-toolbar-title>{{getExerciseTitle(exerciseIndex)}} - {{exercises[exerciseIndex].type}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>   

      <div style="position: relative;">

        <v-overlay
            position: absolute
            :opacity=0.1
            :value=displayProgressBar
          >
          <!--    COUNT DOWN PROGESS    -->
          <div v-if="countdownTimerEnabled">
             
             <v-progress-circular :size="300" :width="20" color="rgba(190, 24, 90, 0.6)" :value="timerCountPercentage">
              <div  v-if="slideIsRunning"    class="text-h2 white--text text--darken-2">  {{totalTimerCountFormatted}}  </div>
              <div  v-if="displayCountDown"    class="text-h1 white--text">  {{countdownTimerCount}} </div>

             </v-progress-circular>
          </div>
          </v-overlay>



        <!--       MAIN IMAGE       -->
        <v-img v-if="exercises[exerciseIndex].mediaType==='gif'" width="550px" v-bind:src="exercises[exerciseIndex].image">
            <!--color="rgba(255, 0, 0, 0.5)"  blue lighten-4 -->
          
          <!-- NEW EXERCISE -->
          <v-overlay
            position: absolute
            :opacity=0.3
            :value=showInstructions
          >

          <!-- HOW TEXT -->

              <v-card
                class="mx-auto"
                max-width="500"
                outlined
              >
              <v-card-title>Instructions</v-card-title>
            <v-card-text class="mt-0 mb-0 pa-0 pl-6" v-for="(item) in exercises[exerciseIndex].how" :key="item.id">
                <p class="text-body-1">{{ item }}</p>
            </v-card-text>
        </v-card>
      
          </v-overlay>

        <!--    CARD TITLE   -->

        <v-card-title></v-card-title>
    </v-img>


    <!-- MUSE PLAYER -->
     
      <MusePlayer v-if="exercises[exerciseIndex].mediaType==='video' && displayVideo" :videoOptions="videoOptions" @play="handlePlay" @pause="handlePause" ref="musePlayer">
       
             <template v-slot:overlay-content>
              <v-card
                class="mx-auto"
                max-width="500"
                outlined
              >
              <v-card-title>Instructions</v-card-title>
            <v-card-text class="mt-0 mb-0 pa-0 pl-6" v-for="(item) in exercises[exerciseIndex].how" :key="item.id">
                <p class="text-body-1">{{ item }}</p>
            </v-card-text>
        </v-card>
        </template>     

        </MusePlayer>


       </div>
      


  <!-- SESSION PROGRESS   -->
        <div v-if="displaySessionProgress">
          <v-row no-gutters style="height: 20px;">
            <v-col>
            <v-progress-linear color="rgba(190, 24, 90, 0.6)" height="30" :value="sessionWorkoutProgress">
              <div class="text-h5 white--text">{{totalWorkoutTimeFormatted}}</div>
            </v-progress-linear>
            </v-col>
          </v-row>   
        </div>   

    <div v-if="displayControls">
      <v-row no-gutters class="pa-4" style="height: 100px;" align-content="center"  align="center">     
      
       <v-col  cols="4" align="left">
          <v-btn v-bind="controlButtonSize" class="ma-2"   outlined  color="pink lighten-2 white--text"  dark @click="closeTheSession()">Exit
            <v-icon dark right>mdi-location-exit
          </v-icon>
        </v-btn>
        </v-col>
        <v-col  cols="4" align="center">
              <v-btn v-bind="playButtonSize" v-if="repCountdownTimerEnabled" class="ma-2"  outlined color="pink darken-2 white--text"  dark @click="pause()">Pause
          <v-icon dark right>
            pause
          </v-icon>
          <v-spacer/>
        </v-btn>

        <v-btn v-bind="playButtonSize" v-else-if="!endOfSession"  class="ma-2"  outlined color="pink darken-2 white--text"  dark @click="play()">Start
            <v-icon dark right v-bind="IconButtonSize">play_circle</v-icon>
        </v-btn>   
        </v-col>
        <v-col  cols="4" align="right">
  

            <v-btn v-bind="controlButtonSize"  v-if="!endOfSession" class="ma-2"   outlined  color="pink lighten-2 white--text"  dark @click="next()">Next
            <v-icon dark right>skip_next
          </v-icon>
        </v-btn>

        </v-col>

      </v-row>          
    </div>


  <!-- Duration Control -->
  <v-expand-transition>
    <v-card  color="grey darken white--text"  dark   v-show="showExeriseEditControls">
    <v-row v-if="showExeriseEditControls"  dense class="pl-4">  
      <v-col  cols="8" >
        <v-slider
          v-model=exercises[exerciseIndex].displayDuration
          step="15"
          max="180"
          min="30"
          color="white"
          track-color='white'
          label="Duration"
          ticks
        @change="durationSet"
                >
              </v-slider>
          </v-col>
          <v-col cols="2" >
             {{exercises[exerciseIndex].displayDuration}} secs
          </v-col>
          <v-col cols="2" >         
          </v-col>

        </v-row>

        </v-card>    
        </v-expand-transition>



  <!-- NEXT EXERCISE PREVIEW -->
  <v-row v-if="nextExercise>0" no-gutters class="grey lighten-2 grey--text text--darken-3" align-content="center">
    <span class="mt-2 pa-2">Next</span>

    <v-list-item-avatar>
      <v-img :src="exercises[nextExercise].image" :max-width="40"></v-img>
    </v-list-item-avatar>
    <v-list-item-content>

      <v-list-item-title v-text="exercises[nextExercise].title" class="ml-2"></v-list-item-title>
      <v-list-item-subtitle class=" ml-2 grey--text text--darken-3" v-text="targetText"></v-list-item-subtitle>
      <!--v-list-item-subtitle>
      <v-chip :color="item.color" small pill class="white--text" >{{exercises[nextExercise].duration}}</v-chip>
      </v-list-item-subtitle-->
    </v-list-item-content>

    <v-list-item-action>

      
      <v-chip color="grey darken-1" small pill class="white--text">{{exercises[exerciseIndex].type}}</v-chip>
    </v-list-item-action>
  </v-row>



  </v-card>

  </v-container>

 

</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>

import MusePlayer from '@/components/MusePlayer.vue';
import { Auth } from 'aws-amplify'  

export default {

  name: 'Session',
  components: {
    MusePlayer
  },
  data: () => ({
    setID: null,
    displayVideo: true,
    sessionCompleted: false,
    currentUser: null,
    displayControls:true,
    slideIsRunning:false,
    showNewExercise:false,
    displaySessionProgress:true,
    displayHow: true,
    countdownTimer:5,
    repCountdownValue: 0,
    timerDuration:10,
    sessionWorkoutProgress:0,
    showInstructions: false,
    displayCountDown:false,
    workoutTime:0,
    totalWorkoutTime:-1,
    currentSet: [],
    exercises:[],
    exerciseIndex: 0,
  // timer/progress
    countdownTimerEnabled: false,
    countdownTimerCount: 10,
    timerCount: 0, // set in the call the resetDisplay() in created hook. Needs to be none 0 at the start    
    displayProgressBar: true,
    repCountdownTimerEnabled: false,
    showExeriseEditControls: true,
    timerCountPercentage: 0,
    endOfSession: false,
    videoOptions: {
        video: null,
        width: '550px',
        style: 'no-controls',
        loop: true,
        showOverlay: false
      }  
 
  }),
  async created() {
     this.userAuthData = await Auth.currentUserInfo();

    try {
      this.currentSet = this.$store.getters.getCurrentSet
   
    console.log("this.$store.getters.getCurrentSet")
    console.log(this.$store.getters.getCurrentSet)

    } catch(err) {
      console.log("queries.getSetExercises Error: " + err)
      this.$router.push('home');
    }

    try {
      this.exercises=this.currentSet.exercises
    } catch(err) {
      console.log("this.currentSet.exercises Error: " + err)
      this.$router.push('home');
    }

    try {
      console.log("Calling setUpExerciseData....")
      this.setUpExerciseData()
      console.log("Called setUpExerciseData....")
    } catch(err) {
      console.log("setUpExerciseData Error: " + err)
      this.$router.push('home');
    }

    try {
      this.setupFirstExercise()    
    } catch(err) {
      console.log("setupFirstExercise Error: " + err)
      this.$router.push('home');
    }

    try {
      this.resetDisplay()
    } catch(err) {
      console.log("resetDisplay Error: " + err)
      this.$router.push('home');
    }



    

  },
  
  async mounted() {

    },   
    watch: {
      //https://stackoverflow.com/questions/55773602/how-do-i-create-a-simple-10-seconds-countdown-in-vue-js
        countdownTimerEnabled(value) {
         
            if (value) {
                setTimeout(() => {
                    this.countdownTimerCount--;
                }, 1000);
            }
        },
        countdownTimerCount: {
            handler(value) {
            
                if (value > 0 && this.countdownTimerEnabled) {
                    setTimeout(() => {
                        this.countdownTimerCount--;
                      
                    }, 1000);
                } else {
                  if(!this.sessionCompleted) {
                  console.log("Calling Play A");
                  this.play();
                }
                  //console.log("TIMER FINISHED");
                }

            },
            immediate: true // This ensures the watcher is triggered upon creation
        },

        repCountdownTimerEnabled(value) {
            if (value) {
                setTimeout(() => {
                    this.timerCount--;
                }, 100);
            }
        },
        timerCount: {
            handler(value) {

                if (value < this.timerDuration) {
                  if(this.repCountdownTimerEnabled) {
                    setTimeout(() => {

                        this.timerCountPercentage=(this.timerCount/this.timerDuration) * 100;
                        let sessionPercent = (this.totalWorkoutTime/this.totalSessionDuration) *100;
                        this.sessionWorkoutProgress=sessionPercent;

                        this.totalWorkoutTime++;
                        this.timerCount++; 
                          
                    }, 100);
                  }
                } else {

                  this.updateDailyTotal(this.timerCount);
                  this.cooldownTime=0;
                  this.workoutTime=0;
                  this.cooldownTime=0;
                  
                  // Called on next()   this.resetDisplay();
                  this.next();
                 // this.repCountdownTimerEnabled = false
                }

            },
            immediate: true // This ensures the watcher is triggered upon creation
        }
      },    
      computed: {
       // a computed getter
         controlButtonSize () {
            const size = {xs:'x-small',sm:'small',md:'small', lg:'',xl:'large'}[this.$vuetify.breakpoint.name];
            return size ? { [size]: true } : {}
          },
          playButtonSize () {
            const size = {xs:'x-small',sm:'',md:'large', lg:'large',xl:'large'}[this.$vuetify.breakpoint.name];
            return size ? { [size]: true } : {}
          },
          IconButtonSize () {
            const size = {xs:'',sm:'',md:'large', lg:'large',xl:'large'}[this.$vuetify.breakpoint.name];
            return size ? { [size]: true } : {}
          },
          testButtonSize () {
            return this.$vuetify.breakpoint.name;
          },
        targetText() {
        return ("Target: " + this.exercises[this.exerciseIndex].target)
        },
      showNextExercise: function () {
          return(this.exerciseIndex < this.exercises.length - 1); 
        },         
      nextExercise: function () {
          //console.log("nextExercise: length" + this.exercises.length);
          let next = this.exerciseIndex;
          next++;
          //console.log("next:" + next);

          if(next < this.exercises.length) {
            return(next);
          } else {
            //console.log("nextExercise: 0");
            return(0); 
          }
          
        },         
        totalSessionDuration: function () {
          let total=0;
        for (let i = 0; i < this.exercises.length; i++) {  //loop through the array
          total += this.exercises[i].duration;  //Do the math!
        }

        return total;
        },

        totalTimerCountFormatted: function () {
          return(Math.round(this.timerCount/10));
        }, 
        totalWorkoutTimeFormatted: function () {
          return(Math.round(this.totalWorkoutTime/10));
        },        
      },     
  methods: {

    handlePlay() {
      console.log('Play event triggered');
      // Handle play event
      // Perform any actions you want when the play event occurs
    },
    handlePause() {
      console.log('Pause event triggered');
      // Handle pause event
      // Perform any actions you want when the pause event occurs
    },
    playVideo() {
      this.$refs.musePlayer.player.play();
    },
    pauseVideo() {
      this.$refs.musePlayer.player.pause();
    },
    changeVideo(video) {
      this.videoOptions.video=video

    },
    getExerciseTitle(index) {
        let count=0;
        let indexOffset=0;
        let titleString=""
        
        try {
          count = this.exercises.length;
          indexOffset = index + 1
          titleString = this.exercises[index].title + " (" + indexOffset + "/" + count  + ")";

        } catch(err) {
          console.log("getExerciseTitle: Error: " + err)
        }

        return(titleString);
      },

    setUpExerciseData() {
      console.log("setUpExerciseData")
    // Exercise data is returned with a long, nested hierarchy. Flatten and merge with sequences


      let exercises=this.currentSet.exercises
    // tidy up the structure...
    let tempExerciseList=[]
    for(let i=0;i<exercises.items.length;i++) {
      tempExerciseList.push(exercises.items[i].exercise);
    }



      let sequences;
      try { 
  
        sequences=JSON.parse(this.currentSet.sequences)
      }  catch (ex) {
          sequences=this.currentSet.sequences
        } 


    // Iterate over each sequence
    sequences.forEach(sequence => {
        // Find the corresponding exercise in the exercises array
        let exercise = exercises.items.find(item => item.exercise.id === sequence.exercise);
        console.log("FIND....")
        console.log("SequenceID: " + sequence.exercise)
        console.log(exercise)

        // If exercise is found, add the sequence property to it
        if (exercise) {
            exercise.exercise.sequence = sequence.sequence;
        }
    });


      // Sort the exercises into 'sequence' order
      const map = new Map();
      sequences.forEach(item => map.set(item.exercise, item));


      tempExerciseList.forEach(item => map.set(item.id, {...map.get(item.id), ...item}));

      const mergedData = Array.from(map.values());

      this.exercises=mergedData;


      // convert the How JSON OBJECTS
      for(let i=0;i<this.exercises.length;i++) {
          this.exercises[i].how = JSON.parse(
            
            this.exercises[i].how
            )
      } 


    },         
  setupFirstExercise() {

      this.displayControls=true;
      this.displaySessionProgress=true;

      this.showInstructions=true;
      this.videoOptions.showOverlay=true


      // Initialise first video
      if(this.exercises[0].mediaType=='video') {
        this.videoOptions.video = this.exercises[0].videoID;
      }
    },    
    play() {
        this.showInstructions=false;
        this.videoOptions.showOverlay=false
        this.displayCountDown=false;

        this.displayProgressBar=true;
        this.slideIsRunning=true;
        this.repCountdownTimerEnabled = true;
        this.showExeriseEditControls = false;
        try {
            this.timerDuration=this.exercises[this.exerciseIndex].duration;
        }
         catch (ex) {
          console.log('Play. Error. May not be a problem if called from the timer method (countdownTimerCount)?', ex.message);
        }
        
        if(this.exercises[this.exerciseIndex].mediaType=='video') {
          this.playVideo(this.exercises[this.exerciseIndex].videoID);
        }
               
    },
    resetDisplay() {

      this.displayProgressBar=true;
      this.repCountdownTimerEnabled=false;
      this.repCountdownValue=0;
      if(this.currentSet.owner!='microcise') {
        this.showExeriseEditControls = true;
      }

      this.timerCount=0;
      this.timerCountPercentage=0;
      this.endOfSession=false;

  
      },
    pause() {
        console.log("showInstructions=true")
        this.showInstructions=true;
        this.videoOptions.showOverlay=true;
        this.repCountdownTimerEnabled = false;
        this.slideIsRunning=false;
        this.pauseVideo();
      
    },
    next() {
      console.log("next()")
      this.slideIsRunning=false;
      if(this.exerciseIndex < this.exercises.length - 1) {
        this.countdownTimerCount=10;
        this.countdownTimerEnabled = true;
        this.showInstructions=true;
        this.videoOptions.showOverlay=true;
        this.displayCountDown=true;
        this.exerciseIndex++;
        
        if(this.exercises[this.exerciseIndex].mediaType==='video') {

          this.changeVideo(this.exercises[this.exerciseIndex].videoID)
        }
      
        this.resetDisplay();

      } else {
       
        this.closeTheSession();
      }
    },
    previous() {
      if(this.exerciseIndex > 0) {
      
        this.resetDisplay();
        this.exerciseIndex--;
      }
    },

    closeTheSession() {
        this.sessionCompleted=true;
        this.resetDisplay();
        this.displayControls=false;
        this.displaySessionProgress=false;
        this.displayProgressBar=false;
        this.videoOptions.showOverlay=false;
        this.displayVideo=false;
        this.displayProgressBar=false;
        this.showExeriseEditControls = false;
        this.endOfSession=true;

        this.countdownTimerEnabled=false;
        this.totalWorkoutTime=3000
        this.$router.push({ path: 'endOfDemoSession', query: { totalWorkoutTime: this.totalWorkoutTime } })

    },
  durationSet(value) {

    this.exercises[this.exerciseIndex].duration = value *10
    //let durationData : { "duration": value,"index" : this.exerciseIndex};
    //let jsonData =  '{ "setId": ' + this.currentSet.id +' , "exerciseIndex": ' + this.exerciseIndex  +' , "duration": ' + value + '}';
    //let jsonData =  '{ "duration": ' + value +' , "index": ' + this.exerciseIndex + '}';
    //const jsonObj = JSON.parse(jsonData);             
    //this.$store.dispatch('currentDuration', jsonObj);
  },
    updateDailyTotal(exerciseTime) {
      
       console.log("addTimetoSessionToday " + exerciseTime);
    }      
  }          
}
</script>


<style>

.endCard {
  position: absolute;
  top: 50;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Add a semi-transparent background for the overlay effect */
  /* Add any other styles for the overlay content */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

